/**
 * Copyright (C) Sitevision 2002-2024, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-tellfriend-portlet')) {
  import(/* webpackChunkName: "tellfriend-portlet" */ './tellFriend');
}
